import { useFormContext } from 'react-hook-form';

const hasBookPhotographerTask = () => {
  const { watch } = useFormContext();
  const basicPackage = watch('basicPackage')?.tasks;
  return basicPackage?.includes('bookPhotographer');
};

export default hasBookPhotographerTask;
